module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/embroidery-5672f33292cba70f24e0885bf419109f.jpg";